import { Row } from "react-bootstrap";

import {
  DEFAULT_VALUE,
  PERCENTAGE_FORMAT_CONSTANTS,
} from "../../constants";
import { compactNumberFormat } from "../../../../shared";
import {
  BRAND_REPORT_LABELS,
  BRAND_REPORT_INSIGHT_TITLES,
  BRAND_REPORT_INSIGHT_COPY,
} from "../../constants/brandReport.constants";
import {
  getBestChannel,
  getChannelCardInfo,
  getCompletionDescription,
  getTotalSurveysDescription,
} from "./utils/brandReportHelpers";
import InsightCard from "./components/insightCard";

const KeyInsights = ({ data }) => {
  const posSurveyCount =
    data?.pos?.totalSurveySentCount?.value || DEFAULT_VALUE;
  const onlineSurveyCount =
    data?.online?.totalSurveySentCount?.value || DEFAULT_VALUE;
  const total = posSurveyCount + onlineSurveyCount;

  // Determine description based on available channels
  const hasPosData = posSurveyCount > DEFAULT_VALUE;
  const hasOnlineData = onlineSurveyCount > DEFAULT_VALUE;

  // Overall Completion calculation based on actual totals
  const posCompleted =
    data?.pos?.totalSurveyCompleteCount?.value || DEFAULT_VALUE;
  const onlineCompleted =
    data?.online?.totalSurveyCompleteCount?.value || DEFAULT_VALUE;
  const posOpened = data?.pos?.totalSurveyOpenedCount?.value || DEFAULT_VALUE;
  const onlineOpened =
    data?.online?.totalSurveyOpenedCount?.value || DEFAULT_VALUE;
  const totalCompleted = posCompleted + onlineCompleted;
  const totalOpened = posOpened + onlineOpened;
  const completed =
    totalOpened > DEFAULT_VALUE
      ? (totalCompleted / totalOpened) * PERCENTAGE_FORMAT_CONSTANTS.MULTIPLIER
      : DEFAULT_VALUE;

  // Positive Response calculation based on actual totals
  const posPositive =
    data?.pos?.totalPositiveSurveyCompleteCount?.value || DEFAULT_VALUE;
  const onlinePositive =
    data?.online?.totalPositiveSurveyCompleteCount?.value || DEFAULT_VALUE;
  const totalPositive = posPositive + onlinePositive;
  const positive =
    totalCompleted > DEFAULT_VALUE
      ? (totalPositive / totalCompleted) * PERCENTAGE_FORMAT_CONSTANTS.MULTIPLIER
      : DEFAULT_VALUE;

  const posCompletion =
    data?.pos?.totalSurveyCompleteCount?.percentage || DEFAULT_VALUE;
  const onlineCompletion =
    data?.online?.totalSurveyCompleteCount?.percentage || DEFAULT_VALUE;
  const bestChannel = getBestChannel(posCompletion, onlineCompletion);
  const percentageDifference = Math.abs(posCompletion - onlineCompletion);

  // Determine if single channel scenario and get channel info
  const isSingleChannel =
    (hasPosData && !hasOnlineData) || (!hasPosData && hasOnlineData);
  const channelCardInfo = getChannelCardInfo({
    isSingleChannel,
    hasPosData,
    bestChannel,
    percentageDifference,
  });

  return (
    <div className="col-12 bg-white rounded-3 shadow-sm mb-4 p-3">
      <h5 className="mb-3">{BRAND_REPORT_LABELS.KEY_INSIGHTS}</h5>
      <Row className="gy-4">
        <InsightCard
          title={BRAND_REPORT_INSIGHT_TITLES.TOTAL_SURVEYS}
          value={compactNumberFormat(total)}
          description={getTotalSurveysDescription({ hasPosData, hasOnlineData })}
        />

        <InsightCard
          title={BRAND_REPORT_INSIGHT_TITLES.OVERALL_COMPLETION}
          value={`${compactNumberFormat(completed)}%`}
          description={getCompletionDescription({ hasPosData, hasOnlineData })}
        />

        <InsightCard
          title={BRAND_REPORT_INSIGHT_TITLES.POSITIVE_RESPONSE}
          value={`${compactNumberFormat(positive)}%`}
          description={BRAND_REPORT_INSIGHT_COPY.OF_COMPLETED_SURVEYS}
        />

        <InsightCard
          title={channelCardInfo.title}
          value={channelCardInfo.value}
          description={channelCardInfo.description}
        />
      </Row>
    </div>
  );
};

export default KeyInsights;
